module.exports = __webpack_public_path__ + "static/media/im.bd01c1fa.svg";